import React, { useState, useEffect } from "react";
import moment from "moment";
import prevArrow from "src/assets/i_arrow_prev.svg";
import nextArrow from "src/assets/i_arrow_next.svg";

interface DateButtonProps {
  todayDate: string;
  onDateChange: (newDate: string) => void;
}

const DateButton: React.FC<DateButtonProps> = ({ todayDate, onDateChange }) => {
  const [currentDate, setCurrentDate] = useState(moment(todayDate, "YYYYMMDD"));
  const today = moment().format("YYYYMMDD");

  useEffect(() => {
    onDateChange(currentDate.format("YYYYMMDD"));
  }, [currentDate, onDateChange]);

  const handlePrevDate = () => {
    setCurrentDate(prevDate => prevDate.clone().subtract(1, "days"));
  };

  const handleNextDate = () => {
    if (currentDate.format("YYYYMMDD") < today) {
      setCurrentDate(prevDate => prevDate.clone().add(1, "days"));
    }
  };

  return (
    <div className="date-btn d-flex align-items-center justify-content-center gap-2">
      <button type="button" onClick={handlePrevDate}>
        <img src={prevArrow} alt="Previous" />
      </button>
      <p>{currentDate.format("YYYY.MM.DD")}</p>
      <button
        type="button"
        onClick={handleNextDate}
        style={{ visibility: currentDate.format("YYYYMMDD") >= today ? "hidden" : "visible" }}
      >
        <img src={nextArrow} alt="Next" />
      </button>
    </div>
  );
};

export default DateButton;
